<template>
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.313 0.330324C16.7102 0.329699 17.0929 0.482129 17.3843 0.75701C17.6757 1.03189 17.8542 1.40887 17.884 1.81227V1.93245V11.5452C17.8841 11.9494 17.7342 12.3387 17.4644 12.6351C17.1946 12.9314 16.8247 13.113 16.429 13.1433H16.311H3.73C3.33316 13.1434 2.95095 12.9907 2.65998 12.7159C2.369 12.4411 2.19076 12.0644 2.161 11.6613V11.5412V10.7406H3.73V11.5412H16.313V3.06505L10.855 8.62412C10.6485 8.83417 10.373 8.95886 10.0816 8.97409C9.79012 8.98933 9.50348 8.89404 9.277 8.70662L9.184 8.62412L3.73 3.06505V3.53458H2.157V1.93245C2.15588 1.52757 2.30531 1.13727 2.57524 0.840037C2.84518 0.542807 3.21559 0.360696 3.612 0.330324H3.73H16.313ZM5.303 7.5394C5.51159 7.5394 5.71164 7.6238 5.85914 7.77402C6.00663 7.92425 6.0895 8.12801 6.0895 8.34046C6.0895 8.55292 6.00663 8.75667 5.85914 8.9069C5.71164 9.05713 5.51159 9.14153 5.303 9.14153H1.37C1.1614 9.14153 0.961354 9.05713 0.813857 8.9069C0.666359 8.75667 0.583496 8.55292 0.583496 8.34046C0.583496 8.12801 0.666359 7.92425 0.813857 7.77402C0.961354 7.6238 1.1614 7.5394 1.37 7.5394H5.303ZM15.203 1.93245H4.842L10.022 7.20838L15.203 1.93245ZM4.516 5.13671C4.71709 5.13579 4.91089 5.2134 5.05751 5.35359C5.20413 5.49378 5.29241 5.68587 5.3042 5.89034C5.31599 6.09481 5.25038 6.29611 5.12087 6.45281C4.99137 6.6095 4.80782 6.70968 4.608 6.73273L4.516 6.73884H2.157C1.9559 6.73977 1.7621 6.66215 1.61548 6.52197C1.46886 6.38178 1.38058 6.18969 1.36879 5.98522C1.35701 5.78074 1.42262 5.57945 1.55212 5.42275C1.68163 5.26605 1.86517 5.16587 2.065 5.14282L2.157 5.13671H4.516Z"
            :fill="'var(--button-color)'"
        />
    </svg>
</template>
<script>
export default {
    name: "LeaveMessage",
    props: ["color"],
};
</script>
<style scoped>
svg {
    fill: var(--button-color);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/svg/components/LeaveMessageIcon.vue